import { render } from "./BuildingKitAiTesting.vue?vue&type=template&id=e11d4ee8&lang=pug"
import script from "./BuildingKitAiTesting.vue?vue&type=script&lang=js"
export * from "./BuildingKitAiTesting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__